module.exports = __webpack_public_path__ + "static/media/question_mark.9628fdb9.png";